import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import postPaymentOrderCardToCardTransaction from './postPaymentOrderCardToCardTransaction';
import {
  ICreateOrderCardToCardTransactionPayload,
  ICreateStoreOrderCardToCardTransactionResponse,
} from './types';

const usePostPaymentOrderCardToCardTransaction = (
  handleAfterSuccess?: (
    data: ICreateStoreOrderCardToCardTransactionResponse,
  ) => void,
) => {
  const {isLoading, mutate, isSuccess} = useMutation<
    ICreateStoreOrderCardToCardTransactionResponse,
    AxiosError<IAxiosErr>,
    ICreateOrderCardToCardTransactionPayload
  >({
    mutationFn: postPaymentOrderCardToCardTransaction,
    onSuccess: data => handleAfterSuccess?.(data),
    onError: error => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostPaymentOrderCardToCardTransaction;
